// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"53420930","455":"75f4d7fa","977":"61129e51"}[chunkId] + ".chunk.js";
};